// activity.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  private activitySubject = new Subject<void>();

  activity$ = this.activitySubject.asObservable();

  // Appelé à chaque activité détectée
  reportActivity() {
    this.activitySubject.next();
  }
}
